import {
    IAddPolicy,
    IRule,
    IRuleConfiguration,
    IConditionData,
    ICondition,
    IElseActionData,
    IActionData,
    ConditionTypes,
    IAction,
    IElseAction,
    IAdditionalRule,
} from '@app/models';

export const prepareData = (mainRule: IRule, policyName: string, defaultPolicy: boolean): IAddPolicy => {
    return {
        '@odata.type': 'Kaseya.AuthAnvil.Models.EnhancedAuthenticationPolicy',
        Configuration: preparePolicyConfiguration(mainRule),
        DisplayName: policyName,
        IsDefault: defaultPolicy
    };
};

export const prepareConditions = (rule: IRule | IAdditionalRule) => {
    let conditions: IConditionData[] = [];

    rule.conditions.forEach((condition: ICondition) => {
        if (condition.object !== null) {
            if (condition.object.type === ConditionTypes.forwardIP || condition.object.type === ConditionTypes.ip) {
                conditions.push({
                    type: ConditionTypes.ipConf,
                    property: condition.object.property,
                    filter: condition.object.filter
                });
            } else {
                conditions.push({
                    type: condition.object.type,
                    property: condition.object.property,
                    filter: condition.object.filter
                });
            }
        }
    });

    return conditions;
};

export const prepareActions = (rule: IRule | IAdditionalRule) => {
    let actions: IActionData[] = [];

    rule.actions.forEach((action: IAction) => {
        if (action.object !== null) {
            actions.push({
                Type: action.object.Type,
                Configuration: action.object.Configuration
            });
        }
    });

    return actions;
};

export const prepareElseActions = (rule: IRule) => {
    let elseActions: IElseActionData[] = [];

    rule.elseActions.forEach((elseAction: IElseAction) => {
        if (elseAction.object !== null) {
            elseActions.push({
                Type: elseAction.object.Type,
                Configuration: elseAction.object.Configuration
            });
        }
    });

    return elseActions;
};

const preparePolicyConfiguration = (mainRule: IRule): string => {
    let configuration: IRuleConfiguration = {
        operator: mainRule.operator,
        conditions: prepareConditions(mainRule),
        actions: prepareActions(mainRule),
        elseRules: [],
        elseActions: prepareElseActions(mainRule),
    };

    mainRule.elseRules.forEach((rule: IAdditionalRule) => {
        configuration.elseRules.push({
            operator: rule.operator,
            conditions: prepareConditions(rule),
            actions: prepareActions(rule)
        });
    });

    return JSON.stringify([configuration]);
};
